import { useMemo } from 'react';
import { DEFAULT_VIEW_CHUNK_LIMIT } from 'src/graphql/entities/custom-view/constants';
import { prepareSortAttributes } from 'src/graphql/entities/custom-view/custom-view-config/utils';
import { CustomViewSorting } from 'src/graphql/entities/custom-view/custom-view.types';
import { useSearch } from 'src/graphql/entities/search/use-search';
import { ConditionInput, EntityNames } from 'src/graphql/types';
import useDebouncedValue from 'src/utils/hooks/use-debounced-value';

// this hook abstracts the interface required for generic custom views table
export const useConversationRecords = ({
  filters,
  sort,
  limit = DEFAULT_VIEW_CHUNK_LIMIT,
  searchTerm,
  dynamicAttributePaths,
}: {
  filters: ConditionInput[];
  sort: CustomViewSorting;
  limit?: number;
  searchTerm?: string;
  dynamicAttributePaths?: string[];
}) => {
  const filter = useDebouncedValue(filters, 500);

  const options = useMemo(() => {
    return {
      searchTerm: searchTerm ?? '',
      filter,
      limit,
      sort: prepareSortAttributes(sort),
      entityName: EntityNames.Conversation,
      showResultsWhenEmptySearchTerm: true,
      dynamicAttributePaths,
    };
  }, [filter, limit, sort, searchTerm, dynamicAttributePaths]);

  const data = useSearch(options);

  if (!data) {
    throw new Error('Search is not configured to search for conversations');
  }

  return data;
};
